<template>
  <div class="Mpmaterial">
    <div class="grouping-name" >
      <van-button v-for="(item, index) in tabbar"
                  :key="index" :name="index"
                  :class="['terminal-btn', { 'selected': activeKey === index }]"
                  icon="/static/images/etv-folder.png"
                  @click="onChange(index)">
        {{ truncatedName(item.name) }}
      </van-button>
    </div>
    <div id="materiallists" class="materiallist abcds">
      <div class="content">
        <div class="photo" :style="{
				height:width + 'px',
				width: width + 'px'
			}" >
          <input type="file" ref="fileInput" @change="handleFileChange" style="display: none;" />
          <van-image class="up_loading"

               src="/static/images/program/updata.png"
               @click="handleClick"
               style="width: 100%; height: 100%;" />

        </div>
        <div :key="index" :style="{
                            height:width + 'px',
                            width: width + 'px'
			        }"
             class="materia-item"
             v-for="(item,index) in materialList" @click="prImg(item)">
          <div class="checkbox" @click.stop="getselevt(item.checked,index)">
            <van-checkbox v-model="item.checked"></van-checkbox>
          </div>
          <van-list style="width:100%;height: 100%;">
            <van-image v-if="'doc' === item.type && item.suffix==='.pdf'" src="/static/images/program/pdf.png"
                 style="width: 100%;height: 100%;"/>
            <van-image v-else-if="item.type === 'doc' && (item.suffix==='.xls' || item.suffix==='.xlsx')" src="/static/images/program/xlsx.png"
                 style="width: 100%;height: 100%;"/>
            <van-image v-else-if="'audio' !== item.type"
                 :src="item.imgUrl"
                 style="width: 100%;height: 100%;" />
            <van-image v-else="" src="/static/images/program/msic.png"
                 style="width: 100%;height: 100%;"/>
          </van-list>
          <div class="audit">
            <span v-if="item.auditState === -1" class="audit0">{{$t('append_field.unreviewed')}}</span>
            <!--              <span v-if="item.auditState === 0" class="audit1">{{$t('append_field.normal')}}</span>-->
            <span v-if="item.auditState === 1" class="audit2">{{$t('append_field.violating')}}</span>
            <span v-if="item.auditState === 2" class="audit3">{{$t('append_field.suspectedViolating')}}</span>

          </div>
          <span class="audit-name">{{ item.name }}</span>
        </div>
      </div>
    </div>
    <div class="groupings">
      <div>
        <van-button color="#006EFF" size="small" @click="back">{{ $t('append_field.back')}} </van-button>
        <span style="margin-right: 10px"></span>
        <van-button color="#006EFF" size="small" @click="selectAll">{{ $t('append_field.select_all')}}</van-button>
      </div>

      <van-button color="#FF5700" size="small" @click="deletes">{{$t('append_field.delete')}}</van-button>
    </div>
    <van-dialog v-model="show" :title="$t('append_field.select_group')"
                show-cancel-button
                @confirm="() => onChange(activeKey)"
                @cancel="show===false"
                class="select-groupings">
      <van-radio-group v-model="activeKey" >
        <van-cell-group inset>
          <van-cell
              class="active-key"
              v-for="(item, index) in tabbar"
              clickable
              :key="index"
              icon="/static/images/etv-folder.png"
              :title="item.name"
              @click="activeKey = index"
          >
            <template #right-icon>
              <van-radio
                  :name="index"
                  @click.stop
              />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-dialog>
    <van-overlay :show="show1">
      <div style="height: 100%;display: flex;justify-content: center;align-items: center">
        <van-loading  size="40px" vertical >{{ msg }}...</van-loading>
      </div>
    </van-overlay>
    <van-dialog v-model="show2" :title="$t('append_field.Up')" :show-confirm-button="false">
      <div style="margin: 30px 0px">
        <div class="updata">
          <van-cell :title="$t('append_field.fileName')">
            <div class="updata-item">{{ fileName }}</div>
          </van-cell>
          <van-cell :title="$t('append_field.fileSize')">
            <div class="updata-item">{{ fileSize }}M</div>
          </van-cell>
          <van-cell :title="$t('append_field.uploadProgress')">
          </van-cell>
          <van-cell>
            <div class="updata-item-right">
              <van-progress :percentage="complete" pivot-color="#006EFF" stroke-width="4" style="width: 100%;"></van-progress>
            </div>
          </van-cell>
          <div class="updata-item">
            <label class="updata-item-left"></label>
            <div style="float: right;margin: 10px 16px 0 0">
              <van-button color="#FF5700" size="small" @click="cancel">{{$t('append_field.cancelAllUploads')}}</van-button>
            </div>
          </div>
        </div>
      </div>
    </van-dialog>
    <van-image-preview v-model="imagesshow" :images="images"  >
    </van-image-preview>
    <van-overlay :show="loading_show" @click="loading_show = false">
      <div class="wrapper" @click.stop>
        <van-loading  size="40px" vertical >{{$t('append_field.loadinga')}}</van-loading>
      </div>
    </van-overlay>
    <van-dialog v-model="dialogMaterial" class="bound-material" >
      <div slot="title" style="font-size: 18px">
        {{ $t('append_field.bound_material') }} <span style="margin-left: 20px">{{ gridData.length }}</span>
      </div>
      <van-cell-group class="table-container" >
        <van-cell>
          <div class="cell-content">
            <div class="bound-material-index">{{ $t('append_field.index') }}</div>
            <div class="bound-material-name" >{{ $t('append_field.taskName') }}</div>
          </div>
        </van-cell>
        <van-cell v-for="(item, index) in gridData" :key="index">
          <div class="cell-content">
            <div class="bound-material-index">{{ index + 1 }}</div>
            <div class="bound-material-name">{{ item.name }}</div>
          </div>
        </van-cell>
      </van-cell-group>
      <div style="font-size: 14px; margin: 10px;">PS: {{ $t('append_field.tip_material') }}</div>
    </van-dialog>
    <van-dialog v-model="proyVisible"  class="bound-material" >
      <div slot="title" style="font-size: 18px">
        {{ $t('append_field.boundpo') }} <span style="margin-left: 20px">{{ polist.length }}</span>
      </div>

      <van-cell-group class="table-container">
        <van-cell>
          <div class="cell-content">
            <div class="bound-material-index">{{ $t('append_field.index') }}</div>
            <div class="bound-material-name" >{{ $t('append_field.task_name')  }}</div>
            <div class="bound-material-index" >{{ $t('append_field.source')  }}</div>
          </div>
        </van-cell>
        <van-cell v-for="(item, index) in polist" :key="index">
          <div class="cell-content">
            <div class="bound-material-index">{{ index + 1 }}</div>
            <div class="bound-material-name"  >{{ item.pmName }}</div>
            <div class="bound-material-index"  >{{ item.platform }}</div>
          </div>
        </van-cell>
      </van-cell-group>
      <div style="font-size: 14px; margin: 10px;" >PS: {{ $t('append_field.bind_progron') }}</div>
    </van-dialog>
    <!-- 禁用上传弹窗   -->
    <van-dialog v-model="showUploadFileDialog" :title="$t('append_field.getUploadendTim')">
      <div class="dialog-content">
        <span>{{ uploadFileText }}</span>
        <span>{{ $t('append_field.getUploadstartTime_tip') }}</span>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {Dialog, Toast} from 'vant'
import qs from 'qs'
import axios from "axios"
import {vBeforeClose} from "@/utils/tool";
import getCosUploading from "@/utils/cos.config";
import {
  classifyFileTypes,
  fileTypeList,
  generateFilePath,
  getFileSuffix,
  handleUploadFile,
} from "@/utils/handleUpload";

function parseDateTime(dateTimeStr) {
  return new Date(dateTimeStr);
}


export default {
  name: 'addImages',
  data() {

    return {
      loading_show:false,
      width: 0,
      number: 0,
      selectImg: [],
      materia: [],
      show: false,
      tabbar: [],
      groupingName: '',
      activeKey: 0,
      materialList: [],
      allmaterialList: [],
      index: 0,
      isHasMore: true,
      isLoading: false,
      checked: '',
      id: 0,
      show1: true,
      FolderIndex: 0,
      msg: this.$t('append_field.loadingb'),
      imagesshow: false,
      images: [],
      show2: false,
      complete: 0,
      source: null,//取消上传
      fileName: "",
      fileSize: 0,
      files:[],
      dialogMaterial:false,
      gridData:[],
      proyVisible:false,
      polist:[],
      allowUpload:false,
      showUploadFileDialog:false,
      uploadFileText:'',
      fileList: [],
      typeUpload:'',
      uploadType:"",//这个是来判断上传方式的，上面那个是返回素材是什么方式上传的，然后来决定要不要拼接
      taskId:''
    }
  },
  mounted() {
    document.title = this.$t('append_field.material_management')
    this.width = document.getElementById('materiallists').clientWidth / 4 - 3
    this.getFolder(0)
    this.getmaterial(1)
    const materiallist = document.getElementsByClassName('abcds')[0]
    materiallist.addEventListener('scroll', this.handleScroll)
    this.selectImg = []

  },
  methods: {
    vBeforeClose,
    errImg(val,data) {
      const maxRetries = 3; // 最大重试次数
      const imgSrc = this.upFileUrl + (data.screenshotUrl? data.screenshotUrl:data.videoViewUrl)
      const retries = val.target.dataset.retries ? parseInt(val.target.dataset.retries) : 0;

      if (retries < maxRetries) {
        val.target.dataset.retries = retries + 1; // 增加重试次数
        // 延迟一段时间后重新加载图片
        setTimeout(() => {
          val.target.src = imgSrc ? imgSrc : "";
        }, 1000); // 1秒后重试
      } else {
        val.target.src = ''; // 超过最大重试次数，使用默认图片
      }

      // 如果图片显示不正常，将其设置为空字符串或默认图片
      if (val.target.src && !val.target.complete) {
        val.target.src = '';
      }
    },
    prImg(data) {
      //判断可预览的文件
      let url=data.screenshotUrl? data.screenshotUrl:data.videoViewUrl
      if([".png", ".jpg", ".jpeg", ".gif"].includes(data.suffix) ){
        if(url.startsWith("http")){
          this.images[0]= url
        }else {
          this.images[0] = this.upFileUrl + url
        }
        this.imagesshow = true
      }else if(['.mp4'].includes(data.suffix)){
        if(url.startsWith("http")){
          window.open(url, '_blank')
        }else {
          this.imagesshow = true
          this.images[0] =this.upFileUrl + url
        }
      }else {
        Toast(this.$t('append_field.viewError'))
      }

    },
    getselevt(sele, index) {
      this.materialList[index].checked = !sele
      this.$set(this.materialList, index, this.materialList[index])
      if (this.selectImg.includes(this.materialList[index])) {
        let i = this.selectImg.indexOf(this.materialList[index])
        this.selectImg.splice(i, 1)
      } else {
        this.selectImg.push(this.materialList[index])
      }

      this.number = this.selectImg.length
    },
    getFolder(index) {
      this.msg = this.$t('append_field.loadingb')
      const p = new Promise((resolve, reject) => {
        this.$ajax.post('/etv/findAllOrOneFolder.json', qs.stringify({
          mtType: '',
          type: 'select',
          id: '',
        })).then(res => {
          if (res.data.code === 0) {
            localStorage.setItem("lastSize",res.data.data.lastSize)
            resolve(res.data.data)
          } else {
            reject()
          }
        })
      })
      p.then(res => {
        this.tabbar = res.children

        this.groupingName = this.tabbar[index].name
        this.id = this.tabbar[index].mfId
      })
    },
    selectAll(){
      const allChecked = this.materialList.every(item => item.checked)
      this.materialList.forEach((item, index) => {
        item.checked = !allChecked
        this.$set(this.materialList, index, item)
        if (!allChecked && !this.selectImg.includes(item)) {
          this.selectImg.push(item)
        } else if (allChecked && this.selectImg.includes(item)) {
          let i = this.selectImg.indexOf(item)
          this.selectImg.splice(i, 1)
        }
      });
      this.number = this.selectImg.length
    },
    async deletes() {
      //把vuex里全选出来的数据存到this.clids和this.types，由于他们是应用的是同一个存储空间所以改变一个的值另一个也会改变
      this.clids = this.checkId

      let deleteObj = []

      if (this.selectImg.length < 1) {
        Toast(this.$t('append_field.selectMaterial'))
        return
      }

      for (let i = 0; i < this.selectImg.length; i++) {
        let obj = {}
        obj= this.selectImg[i].mtId
        deleteObj.push(obj)
      }

      //查询素材是否绑定了节目和文件夹是否为空;ps:只能删除空文件夹;
      // eslint-disable-next-line no-unused-vars


      Dialog.confirm({
        title: this.$t('append_field.deleteMaterial'),
        message: this.$t('append_field.confirmDeleteMaterial'),
      }).then(() => {
        this.$ajax.post(`${this.upFileUrl}etv/deleteMtMaterial.json`,qs.stringify({
          mtIds:  deleteObj.join(',')
        })).then(res => {
          if (res.data.code == 0) {
            let data=res.data.data
            if(data.delCount === 0){
              if(deleteObj.length=== 1){
                this.polist = data.respLst[0]?data.respLst[0].pmList:[]
                if (this.polist.length > 0) {
                  this.proyVisible = true
                }else {
                  this.polist = []
                }
              }else {
                if (data.respLst.length> 0) {
                  this.dialogMaterial = true
                  this.gridData =data.respLst
                }
              }

            }else {
              if (data.respLst.length> 0) {
                this.dialogMaterial = true
                this.gridData = data.respLst
              }
              Toast(res.data.msg)
              this.selectImg.length = 0
              this.getmaterial(this.tabbar[this.FolderIndex].mfId)
              this.getFolder(this.activeKey)
            }

          } else {
            Toast(res.data.msg)
          }
        }).catch(err => {
          console.log(err)
        })

      }).catch(() => {

      })
    },//删除文件或者文件夹
    onChange(index) {
      if (this.activeKey !== index) { // 避免不必要的变更
        this.activeKey = index // 更新活动键
      }
      this.index = -1
      this.FolderIndex = index
      this.groupingName = this.tabbar[index].name
      this.getmaterial(this.tabbar[index].mfId)
      this.id = this.tabbar[index].mfId
      this.show1 = true
      this.selectImg = []
    },
    truncatedName(fullName) {
      // 截断名称并确保括号内容完整显示
      const namePart = fullName.split(' (')[0]
      const infoPart = fullName.includes('(') ? `${fullName.slice(fullName.indexOf('('))}` : ''
      if (namePart.length  <= 4) {
        return fullName
      } else {
        return `${namePart.substring(0, 4)}...${infoPart}`
      }
    },
    getmaterial(id) {
      this.$ajax.post('/etv/findAllMaterial.json', qs.stringify({
        id,
        type: '',
        pageNum: 1,
        pageSize: 99999,
        filterType:0
      })).then(res => {
        this.allmaterialList=[]
        this.materialList=[]
        if (res.data.code === 0) {
          this.number =0
          this.allmaterialList = res.data.data.materialList
          this.allmaterialList.forEach(res => {
            res.checked = false
            const url = res.screenshotUrl? res.screenshotUrl : res.videoViewUrl
            res.imgUrl=this.getUrl(url)
          })
          if(this.index === -1) this.index = 0
          this.materialList = this.allmaterialList.slice(this.index, this.index + 32)
          this.$nextTick(() => {
            this.show1 = false
          })
        }
      })
    },
    handleScroll() {
      //滚动条
      const scrollHeight = document.getElementsByClassName('abcds')[0].scrollTop
      let clientHeight = document.getElementsByClassName('content')[0].clientHeight
      let doch = document.getElementsByClassName('abcds')[0].clientHeight
      //真实高度
      if (clientHeight - doch - scrollHeight < 10) {

        if (this.allmaterialList.slice(this.index * 32, this.index * 32 + 32).length < 32) {
          return
        }
        this.index++
        //...new Set去重
        this.materialList = [...new Set([...this.materialList, ...this.allmaterialList.slice(this.index * 32, this.index * 32 + 32)])]
      }
    },
    // 点击 div 触发的事件
    async handleClick() {
      try {
        const isAllowed = await this.getUploadSet()
        if (isAllowed) {
          this.allowUpload = true
          // 手动触发文件选择对话框,ios需要用setTimeout强制触发
          setTimeout(() => {
            this.$refs.fileInput.click()
          }, 0)
        } else {
          this.allowUpload = false
        }
      } catch (error) {
        Toast(this.$t('append_field.getUploadSet_tip')) // 处理 AJAX 请求失败的情况
        this.allowUpload = false
      }
    },
    // 文件选择变化事件处理
    async handleFileChange(event) {
      const file = event.target.files[0]
      if (file) {
        const lastSize = localStorage.getItem("lastSize") // 获取剩余空间大小
        const fileSizeInMB = file.size / 1024 / 1024 // 计算文件大小（转换为MB）
         if (!fileTypeList.includes(file.name.split('.').pop().toLowerCase())) {
          Toast(this.$t('append_field.unsupportedFormat'))
          return false
        }
        if (lastSize < fileSizeInMB) {
          // 如果文件大小超过剩余空间，显示提示信息
          const remainingSpace = lastSize // 剩余空间大小
          const message = this.$t('append_field.last_size') + ' ' + remainingSpace + 'MB' // 构造包含剩余空间大小的消息
          Toast(message, 'fail') // 显示提示
          return
        }
        if (fileSizeInMB < 38 / 1024 && ["png", "jpg", "jpeg", "gif"].includes(file.name.split('.').pop().toLowerCase())) {
          Toast(this.$t('append_field.file_less_38'))
          return false
        }

        this.fileName = ""
        this.fileSize =""
        this.complete = 0
        /*判断是要本地上传还是cos*/
        if (this.uploadType === 1) {
          //先获取存储桶信息
          await handleUploadFile(this.$ajax)
          this.show2 = true
          this.show1 = true
          this.handleUploadFileCos(file)
        } else {
          this.uploadFile(file)
        }
      }
    },
    handleUploadSuccess(){
      this.getFolder(this.FolderIndex)
      this.getmaterial(this.id)
    },
    // 文件上传处理
    uploadFile(file) {
      this.loading_show = true
      setTimeout(() => {
        // 支持上传的格式
      if (fileTypeList.includes(file.name.split('.').pop().toLowerCase())) {
          this.loading_show = false
          this.show2 = true
          this.complete = 0
          const formData = new FormData()

          this.fileName = file.name
          this.fileSize = (file.size / 1024 / 1024).toFixed(2)
          formData.append('files', file)
          formData.append('id', this.id)

          let cancelToken = axios.CancelToken // Axios使我修改axios原型链了。
          this.source = cancelToken.source()

          this.$ajax.post(this.upFileUrl + 'etv/insertMaterial.json', formData, {
            headers: {
              'contentType': 'multipart/form-data',
            },
            onUploadProgress: progressEvent => {
              var complete = (progressEvent.loaded / progressEvent.total * 100 | 0)
              this.complete = complete
            },
            cancelToken: this.source.token,
          }).then(res => {
            if (res.data.code === 0) {
              Toast(res.data.msg)
              this.handleUploadSuccess()
              this.show2 = false
            } else {
              this.show2 = false
              Toast(res.data.msg)
            }
          }).catch(() => {
            this.show2 = false
            this.loading_show = false
            Toast(this.$t('append_field.cancelAllUploads'))
          })
        } else {
          this.loading_show = false
          Toast(this.$t('append_field.unsupportedFormat'))
        }
      }, 300)
    },
    // 判断是否在禁用上传素材时间
    getUploadSet() {
      return new Promise((resolve, reject) => {
        this.$ajax.post('/etv/getUploadSet.json').then(res => {
          if (res.data.code === 0) {
            this.uploadType=res.data.data.uploadType //获取上传类型 上传类型 0-本地 1-cos上传*/
            const currentTime = new Date() // 获取当前时间
            const startTime = parseDateTime(res.data.data.startTime) // 解析接口返回的开始时间
            const endTime = parseDateTime(res.data.data.endTime) // 解析接口返回的结束时间
            const formattedStartTime = startTime.toLocaleString()// 格式化开始时间
            const formattedEndTime = endTime.toLocaleString() // 格式化结束时间
            // 检查当前时间是否在禁止上传的时间段内
            if (currentTime >= startTime && currentTime <= endTime) {
              this.showUploadFileDialog=true
              this.uploadFileText=`${formattedStartTime}—${formattedEndTime}`
              resolve(false) // 不允许上传
            } else {
              resolve(true) // 允许上传
            }
          } else {
            Toast(this.$t('append_field.getUploadSet_tip'))
            resolve(false) // 出现错误，不允许上传
          }
        }).catch(error => {
          reject(error) // AJAX 请求失败，传递错误
        })
      })
    },
    cancel() {
      if (this.source) {
        this.source.cancel(this.$t('append_field.cancelAllUploads'))
      }
      getCosUploading().cancelTask(this.taskId)
      this.show2 = false
      this.show1 = false
    },
    back() {
      this.$router.back()
    },
    getUrl(url) {

      if (!url) {
        return url
      }
      const isHttpUrl = url.startsWith("http")
      const isMp4 = url.endsWith(".mp4")

      if (isHttpUrl) {
        // 如果是 HTTP URL 且不是 MP4 文件，直接返回 URL
        if (!isMp4) {
          return url
        }
        // 如果是 HTTP URL 且是 MP4 文件，返回错误图片
        return '/static/images/program/video_error.png'
      }
      // 如果不是 HTTP URL，拼接基础 URL 并返回
      return this.upFileUrl + url
    },
    handleUploadFileCos(file) {
        // 源文件
        const suffix = getFileSuffix(file.name)
        let type = '.' + suffix.toLowerCase()
        let typeUpload = classifyFileTypes(type)
        let primaryName = generateFilePath(type, typeUpload)
        this.fileName = file.name
        this.fileSize = (file.size / 1024 / 1024).toFixed(2)
        getCosUploading().uploadFileCos(`${primaryName}`, file,
            (progressData) => {
             this.complete = Math.floor(progressData.percent * 100);
            },
            (err) => {
              if (err === null) {
                console.log(err)
              }
            },
            (err, data) => {
              /* console.log(err,data)*/
              if (err === null) {
                let cosUrl = data.Location

                this.$ajax({//查询在线设备离线设备等
                  url: '/etv/createMaterial.json',
                  method: 'post',
                  headers: {
                    'Content-Type': 'application/json',
                    'token': localStorage.getItem('token'),
                  },
                  data: JSON.stringify({
                    "mtUrl": cosUrl,
                    "thumbnailUrl": typeUpload === 'video'?data.thumbnailUrl:"",
                    "mtSize": file.size,
                    "mtMfId": this.id,
                    "mtOgnName": file.name,
                  }),
                }).then(res => {
                  if (res.data.code === 0) {
                    Toast(res.data.msg)
                    this.show2 = false

                    setTimeout(() => {
                    this.handleUploadSuccess()
                    }, 2000)
                  } else {
                    Toast(this.$t('append_field.cancelAllUploads'))
                  }
                })
              }
            },
            (taskId) => {
            this.taskId=taskId
            }
        )
    }
  },
  destroyed() {
    this.materialList = []
  },

}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.Mpmaterial {
  height: 100% !important;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 55;
  background: #ffffff;
  .grouping-name {
    display: flex;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    height: 60px;
    gap: 10px; /* 按钮之间的间隔 */
    align-items: center;
    justify-content: flex-start;
    border-bottom: 1px solid $uni-border-bottom-color;
    overflow-x: auto; /* 水平滚动 */

    .terminal-btn {
      flex: 1 1 auto; /* 自适应宽度 */
      white-space: nowrap; /* 防止文字换行 */
      background-color: white;
      color: black;
      border: 1px solid #ddd; /* 可选：添加边框以便更清晰地看到按钮 */
    }

    .van-button {
      width: 200px !important;
      position: relative;
    }

    .van-button__text {
      display: block;
      width: 100%; /* 使文本占满按钮宽度 */
      white-space: nowrap; /* 确保文本在一行显示 */
      overflow: hidden; /* 超出容器部分隐藏 */
      text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    }

    .selected {
      background-color: #006EFF;
      color: white;
    }
  }
  .van-overlay{
    z-index: 99;
  }
  .materiallist {
    //height: 100%;
    width: 100%;
    padding: 2px;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 75px;
    bottom: 60px;
    overflow: auto;
    .content {
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      justify-content: flex-start;

    }
    .photo {
      box-sizing: border-box;
      padding: 2px;
      margin-top: 8px;
      .van-uploader {
        width: 100%;
        height: 100%;
        border: none;
        display: flex;
        justify-content: center;
        .van-uploader__wrapper {
          width: inherit;
          height: inherit;

          .van-uploader__upload {
            width: inherit;
            height: inherit;
            margin: 0 !important;
            border: none;
          }
        }
      }

      .updata-centnt {
        width: 100%;
        height: 100%;
        border-radius: 5px;

        .updata {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          background: #ffffff;

          .updata-img {
            width: 40%;
            height: 40%;
            margin-bottom: 10px;
          }
        }
      }

    }


    .materia-item {
      position: relative;
      margin: 12px 1px;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      .checkbox {
        z-index: 2;
        position: absolute;
        top: 1px;
        right: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2;

        checkbox {
          width: 25.42px;
          height: 25.42px;
        }
      }

      .image {
        width: 100%;
        height: 100%;
      }
    }
  }

  .groupings {
    display: flex;
    justify-content: space-between;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    height: 60px;
    align-items: center;
    padding: 0 15px;
    box-sizing: border-box;
    border-top: 1px solid $uni-border-bottom-color;

  }
  .select-groupings{
    height: calc(100% - 380px);
  }
  .van-dialog__content{
    height: calc(100% - 40px - 60px);
    overflow-y: auto;
  }
  .dialog-content {
    margin: 45px 16px;
    display: flex;
    flex-direction: column;
    word-wrap: break-word;
    white-space: normal;
    overflow-wrap: break-word;
  }
  .dialog-content span {
    margin-bottom: 8px;
    word-break: break-word;
  }
  .van-cell__title{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .van-icon{
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .van-sidebar {
    width: 100%;
    overflow-y: auto; /* 允许垂直方向滚动 */
    height: 100%; /* 高度设置为100%，或者一个固定的值 */
  }
  .bound-material {
    .table-container {
      height:200px;
      overflow-y: auto;
      [class*=van-hairline]::after{
        border: none;
      }

    }
    .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
      border-width: 0;
    }
    .cell-content {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    .bound-material-index {
      flex: 0 0 20%;
      text-align: center;

    }

    .bound-material-name {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

  }


}

.updata {
  //background: #ffffff;
  //width: 90%;
  //border-radius: 5px;
  //padding: 20px;
  //box-sizing: border-box;

  .updata-title {
    height: 25px;
    margin-bottom: 10px;
    font-weight: 700;
  }

  .updata-item {
    display: block;
    width: 100%; /* 使文本占满按钮宽度 */
    white-space: nowrap; /* 确保文本在一行显示 */
    overflow: hidden; /* 超出容器部分隐藏 */
    text-overflow: ellipsis; /* 使用省略号表示文本被截断 */

  }
  .updata-item-right {
    height: 20px;
    display: flex;
    align-items: center;
    color: #8c8c8c;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.auditContent {
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
.audit-name {
  display: inline-block;
  white-space: nowrap; /* 确保文本在一行显示 */
  overflow: hidden; /* 超出容器部分隐藏 */
  text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
  width: 100%;
  line-height: 22px; /* 设置与高度相同的行高 */
  font-size: 15px;
  color: #131212;
}

.audit{
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
  font-size:  15px;
  white-space: nowrap;
  color: #ffffff;
  .audit0,
  .audit1{
    @extend .auditContent;
    background: rgba(0, 160, 233, 0.61);
  }
  .audit2{
    @extend .auditContent;
    background: rgba(241, 55, 61, 0.79);
  }
  .audit3{
    @extend .auditContent;
    background: rgba(241, 55, 61, 0.79);
  }

}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
